export {Slider} from './slider.class'
export {CraftVue} from './craft-vue.class'